import {
  Box,
  CircularProgress,
  Container,
  LinearProgress,
} from "@mui/material";
// eslint-disable-next-line import/no-unresolved
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AppRouter from "../appRouter";
import useIsBigScreen from "../hooks/useIsBigScreen";
import { logout } from "../auth/auth";
import { useAuthContext } from "../auth/auth-context";

import HeaderLayout from "./header-layout";
import { menuItems } from "./menu-items";
import LogoutIcon from "@mui/icons-material/Logout";

const spDelvePageUrl = "https://liprop-my.sharepoint.com/person.aspx";

const Layout = () => {
  const { state } = useAuthContext();
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const isBigScreen = useIsBigScreen();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.user && state.user.name) {
      setCurrentUser(state.user);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [state]);

  const onAccountProfileClick = () => {
    const delvePageUrl =
      process.env.REACT_APP_SHAREPOINT_DELVE_PAGE_URL || spDelvePageUrl;
    window.open(delvePageUrl, "_blank");
  };
  const hideout = () => {
    const hideList = ["leasedetails", "addlease", "editlease"];
    const checkpath = hideList.filter(
      (e) => window.location.href.indexOf(e) > -1
    );
    if (checkpath.length > 0 && !isBigScreen) {
      return true;
    }
    return false;
  };

  const drawerMenuItems = menuItems(currentUser?.roles, navigate);

  return currentUser ? (
    <>
      {loading ? (
        <LinearProgress />
      ) : (
        !hideout() && (
          <>
            <HeaderLayout
              drawerMenuItems={drawerMenuItems}
              userProfileProps={{
                firstName: currentUser.name ? currentUser.name : "",
                profileURL: currentUser?.profilePicURL,
              }}
              userProfileMenuItems={[
                {
                  text: "Account Profile",
                  onMenuClick: onAccountProfileClick,
                  iconComponent: (
                    <img
                      src={currentUser?.profilePicURL}
                      alt="Profile"
                      style={{
                        width: 25,
                        height: 25,
                        borderRadius: "50%",
                        marginRight: "4px",
                      }}
                    />
                  ),
                },
                {
                  text: "Logout",
                  onMenuClick: logout,
                  iconComponent: <LogoutIcon />,
                },
              ]}
            >
              {" "}
            </HeaderLayout>
            <AppRouter userRole={currentUser?.roles ?? []} />
          </>
        )
      )}
    </>
  ) : (
    <Container fixed sx={{ backgroundColor: "grey.100" }}>
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    </Container>
  );
};

export default Layout;
